import http from '../utils/http';
export default{
    //retrun {promise}
    getMedicalInfoBarcode(barcode){
        let postData = { apiID: 'A4816212-D5D4-40C0-85EE-ADEC95594E7C'//GetMedicalInfo
            , data: { MedicalNo: barcode } };
        return http.post(sys.apiUrl, postData)
    },
    GetMedicalListWithParameItem(ParameItem ,ParameOrderBy=''){
        let postData = { apiID: '6A6898D4-4A7B-43F9-8F95-798A352C2D9D'//GetMedicalListWithParameItem
            , data: {  ParameItem : ParameItem,ParameOrderBy : ParameOrderBy } };
        return http.post(sys.apiUrl, postData)
    },
    GetMedicalListByType(GetType,QueryText,showLoading=null){
        let postData = { apiID: '6F2D7CC9-98E0-4EBA-B26D-E33B3FC03A5E'//GetMedicalList
            , data: {  GetType: GetType, ParameItem: QueryText } };
        if(showLoading)
            return http.post(sys.apiUrl, postData)
        else return http.post(sys.apiUrl, postData,{showLoading:showLoading})
    },
    GetSBDownloadList({MedicalNoWN,SBAddDtimeBegin,SBAddDtimeEnd}){
        let postData = { apiID: 'EC219D4C-89AF-4A2A-BB37-EEA241E0E951'//SBDownloadList
            , data: {  MedicalNoWN: MedicalNoWN, SBAddDtimeBegin: SBAddDtimeBegin,SBAddDtimeEnd:SBAddDtimeEnd} };
        return http.post(sys.apiUrl, postData)
    },

}


// WEBPACK FOOTER //
// ./src/api/medical.api.js